@if (isNewBrand()) {
  <div class="booking-entry relative">
    <cms-disruptions [disruptions]="disruptions$ | async" />

    <div class="grid-max-width grid-col-12" [class.mr-xxsmall-t]="isNewBrand()">
      <div class="col-1-12">
        <fin-content-image
          class="background-image"
          [class.image-position-top]="isCampaignImg()"
          [imageData$]="backgroundImg() | finToObservable"
          [aspectRatio$]="aspectRatio$"
          [fetchPriority]="FetchPriorityEnum.high"
          [isLazyLoad]="false"
        />
        <fin-booking-widget [compactMode]="true" [defaultLocations]="defaultLocations" />
      </div>
    </div>
  </div>
} @else {
  <div class="booking-entry relative">
    <cms-disruptions [disruptions]="disruptions$ | async" />

    <div class="relative bg-container">
      <fin-content-image
        class="background-image"
        [imageData$]="backgroundImg() | finToObservable"
        [aspectRatio$]="aspectRatio$"
        [fetchPriority]="FetchPriorityEnum.high"
        [isLazyLoad]="false"
      />
      <fin-booking-widget [compactMode]="true" [defaultLocations]="defaultLocations" />
    </div>
  </div>
}
